import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useHomeConversionV2({
  branchIds,
  start,
  end,
  groupBy = "none",
  compare,
  enabled = true,
}) {
  const { getConversionMetrics } = useApiV2();
  const { user } = useAuth();

  return useQuery({
    queryKey: [
      "homeConversionV2",
      user?.user_id ?? null,
      branchIds,
      start,
      end,
      groupBy,
      compare ?? null,
    ],
    queryFn: () =>
      getConversionMetrics({
        branch_id: branchIds,
        start,
        end,
        tipo: "presencial",
        group_by: groupBy,
        ...(compare ? { compare } : {}),
      }),
    enabled: Boolean(enabled && branchIds?.length && start && end),
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
